module.exports = __webpack_public_path__ + "img/collection-diamondJewelryWhitegold.c30da02.webp";